// extracted by mini-css-extract-plugin
export default {"tableContainer":"styles_tableContainer__daXYB","table":"styles_table__0+Z02"};